import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';
import { ToastVariants } from '@dotcom/crown-ui';
import { config } from '../../../regional-config';
import { getIsDigitalGreeting } from '../../../utils';
import { useIsOneToMany } from '../../../hooks/use-is-one-to-many';
import { useAppContext, setIsToasterOpen } from '../../../context/app-context';

export const useAddressRegulationToast = (isInitializedDataLoaded: boolean): void => {
  const { isAddressRegulationToastEnabled } = config;
  const isDigitalGreeting = getIsDigitalGreeting();
  const isOneToMany = useIsOneToMany();
  const [cookies, setCookie] = useCookies(['shippingRestrictionToastSeen']);
  const { appDispatch } = useAppContext();
  const { t } = useTranslation();
  const hasShownRef = useRef(false);

  useEffect(() => {
    // isOneToMany depends on async initializedData — wait for it to avoid evaluating a stale value
    if (!isInitializedDataLoaded || hasShownRef.current) {
      return;
    }
    if (
      isAddressRegulationToastEnabled &&
      !isDigitalGreeting &&
      !isOneToMany &&
      !cookies.shippingRestrictionToastSeen
    ) {
      hasShownRef.current = true;
      setIsToasterOpen(appDispatch, {
        title: '',
        children: t('addressView.warningShippingMessage'),
        variant: ToastVariants.Warning,
      });
      // No `domain` option (unlike cleanAccountCookies in src/utils/login.ts) —
      // intentional, this cookie is scoped to the current host only.
      setCookie('shippingRestrictionToastSeen', 'true', {
        path: '/',
        maxAge: 60 * 60 * 24 * 365,
      });
    }
  }, [
    isInitializedDataLoaded,
    isAddressRegulationToastEnabled,
    isDigitalGreeting,
    isOneToMany,
    cookies.shippingRestrictionToastSeen,
    appDispatch,
    setCookie,
    t,
  ]);
};
